import { logo } from "assets/images";
import { Button, LoadingButton } from "components/form";
import { setToken } from "config/axiosInstance";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { reSendOtpApi, verifyOtpApi } from "services/auth";
import { failMessage, successMessage } from "utils/toastMessage";
const OTPScreen = ({ setLoginStep, input }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const [timer, setTimer] = useState(60);
  // ---------timer------------
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);
  //---------send-otp-handler-----------------
  const verifyOtp = async (e) => {
    e.preventDefault()
    if (otp?.length < 4) {
      return failMessage('Please enter your otp')
    }
    try {
      setLoading(true);
      const res = await verifyOtpApi({ ...input, otp: otp });
      if (res?.status === 200) {
        successMessage(res)
        setToken(res?.data?.token || '')
        navigate('/dashboard')
      } else {
        failMessage(res)
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  //--------re-send-otp-handler-----------------
  const ReSendOtp = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (timer > 0) return;
    try {
      setLoading(true);
      const res = await reSendOtpApi(input);
      if (res?.status === 200) {
        successMessage(res);
        setTimer(60);
      } else {
        failMessage(res);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    // onSubmit={verifyOtp}
    <form >
      <img src={logo} className="logo_image" alt="logo" />
      <h2>Enter the OTP code sent to you</h2>
      <p>
        Code sent to <button type="button" >{input?.mobile}</button> unless you
        already have an account <button type="button" onClick={() => setLoginStep('login')} >Edit</button>
      </p>

      <div className="form_field">
        <div className="opt_wrapper">
          <OTPInput
            value={otp}
            onChange={setOtp}
            renderInput={(props) => <input {...props} />}
            numInputs={4}
            inputStyle={"form-control input"}
            inputType="tel"
            shouldAutoFocus={true}
          />
        </div>
      </div>
      {timer > 0 ? (
        <p>Time remaining: <b>{timer}</b> seconds</p>
      ) : (
        <p>
          <button type="button" onClick={ReSendOtp}>
            Resend OTP
          </button>{" "}
          to receive a new code.
        </p>
      )}
      <div className="button_wrap">
        <LoadingButton
          loading={loading}
          type="button"
          onClick={verifyOtp}
        >
          Continue
        </LoadingButton>
      </div>
    </form>
  );
};

export default OTPScreen;
